import { HiOutlineChartBar, HiPlus } from "react-icons/hi";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import hero from '../Images/h2.png'
import officeImg from '../Images/h3.png'
import { useNavigate } from "react-router-dom";

const values = [
  {
    number: "01",
    title: "Integrity",
    // text: "We conduct all our operations with honesty, transparency, and strict adherence to industry standards."
  },
  {
    number: "02",
    title: "Reliability",
    // text: "Our clients depend on us for timely procurement, quality materials, and consistent service delivery across projects."
  },
  {
    number: "03",
    title: "Excellence",
    // text: "We are committed to delivering high-quality products and services that meet global best practices in oil and gas operations."
  },
  {
    number: "04",
    title: "Safety"
  },
  {
    number: "05",
    title: "Social Responsibility"
  },

];

const HeroText = () => {
  const navigate = useNavigate()
  const navtocontact = () => {
    navigate('/contact')
  }
    const navtoservices = () => {
    navigate('/services')
  }
  return (
    <>
      <div className="hero_text ">
        <div className="hero-text">
          <h1 className="wow animate__animated animate__fadeInUp">
            Reliable procurement  for critical projects.
          </h1>

          <p className="wow animate__animated animate__fadeInUp" data-wow-delay="0.2s">
            Lenpec Global Concept Limited delivers trusted procurement solutions
            for oil & gas, construction, and industrial operations across Nigeria.
          </p>

          <div className="btn_div wow animate__animated animate__fadeInUp" data-wow-delay="0.3s" onClick={navtocontact}>
            <button className="cta-btn">
              Send specifications
            </button>
            <button className="cta-btns">
              <MdKeyboardDoubleArrowRight />
            </button>
          </div>
        </div>
        <div className="empty_div"/>
      </div>

      <div className="hero-divider"/>

      <div className="empty_div_layout">
        <div className="herotext"></div>
        <div className="empty_div"/>
      </div>

      <div className="hero-image wow animate__animated animate__fadeInUp" data-wow-delay="1s" >
        <img
          src={hero}
          alt="Industrial operations"
        />
      </div>

      <div className="hero_text"></div>

      <section className="services">
        <div className="services-top">
          <div className="services-intro wow animate__animated animate__fadeInUp" data-wow-delay="1s">
            <span className="label">
              <HiPlus /> What we do
            </span>

            <button className="services-btn" onClick={navtoservices}>View services</button>
          </div>

          <div className="services-text">
            <h2 className="wow animate__animated animate__fadeInUp" data-wow-delay="1s">
              We provide end-to-end procurement and supply services for
              oil & gas, construction, and industrial projects.
            </h2>

            <p className="wow animate__animated animate__fadeInUp" data-wow-delay="1s">
              <span className="icon">
                <HiOutlineChartBar />
              </span>
              Our experienced team sources materials directly from OEMs
              and trusted manufacturers, ensuring quality, compliance,
              and timely delivery.
            </p>
          </div>
        </div>
      </section>

      <div className="hero-divider"/>

      <div className="services-cards">
        <div className="service-card wow animate__animated animate__fadeInUp" data-wow-delay="1s">
          <span className="number">01</span>
          <div className="flex_dem">
            <h3>Industrial Procurement</h3>
            <p>
              Procurement of pipes, steel plates, beams, bars, rods,
              flanges, and fittings for industrial applications.
            </p>
            <button className="detail_btn">
              <HiPlus />
            </button>
          </div>
        </div>

        <div className="service-card wow animate__animated animate__fadeInUp" data-wow-delay="1.5s">
          <span className="number">02</span>
          <div className="flex_dem">
            <h3>Oil & Gas Equipment Supply</h3>
            <p>
              Supply of valves, compressors, turbines, pumps,
              safety materials, and oilfield tools.
            </p>
            <button className="detail_btn">
              <HiPlus />
            </button>
          </div>
        </div>

        <div className="service-card wow animate__animated animate__fadeInUp" data-wow-delay="2s">
          <span className="number">03</span>
          <div className="flex_dem">
            <h3>OEM & Technical Sourcing</h3>
            <p>
              Direct sourcing from original equipment manufacturers
              for pressure vessels, clad plates, and steel sections.
            </p>
            <button className="detail_btn">
              <HiPlus />
            </button>
          </div>
        </div>
      </div>

      <div className="hero-divider"/>

      <section className="mission_section wow animate__animated animate__fadeInUp" data-wow-delay="1s">
        <div className="mission_left">
          <span className="section_label">+ Our mission</span>

          <h2>
            To become one of the best service providers to oil and gas companies; with roots in Nigeria, and a strong international presence.
          </h2>

          <p>
            We support our clients by sourcing compliant materials,
            ensuring timely delivery, and maintaining strong
            quality and HSE standards across all operations.
          </p>

            <div className="btn_div wow animate__animated animate__fadeInUp" data-wow-delay="0.3s" onClick={navtocontact}>
            <button className="cta-btn">
              Work with Us
            </button>
            <button className="cta-btns">
              <MdKeyboardDoubleArrowRight />
            </button>
          </div>
        </div>

        <div className="mission_card">
          <div className="mission_card_header">
            <HiOutlineChartBar />
            <h3>Supporting critical energy and infrastructure projects.</h3>
          </div>

          <div className="mission_graph" />

          <p>
            Our mission is to simplify procurement for complex projects
            by providing dependable materials, technical expertise,
            and strong industry partnerships.
          </p>
        </div>
      </section>

      <section className="values-section">
        <div className="values-container wow animate__animated animate__fadeInUp" data-wow-delay="1s">
          <div className="values-image">
            <img src={officeImg} alt="Industrial collaboration" />
          </div>

          <div className="values-content">
            {values.map((item, index) => (
              <div key={index} className="value-item">
                <div className="value-header">
                  <span className="value-number">{item.number}</span>
                  <h3>{item.title}</h3>
                </div>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="heros">
        <div className="heros-overlay wow animate__animated animate__fadeInUp" data-wow-delay="1s">
          <div className="heros-content">
            <h1>
              Trusted procurement <br /> you can rely on.
            </h1>

            <p>
              Partner with Lenpec Global Concept Limited for dependable
              sourcing, quality assurance, and on-time delivery
              for your next project.
            </p>

            <button className="heros-btn" onClick={navtocontact}>
              Get In Touch
              <span>››</span>
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default HeroText;
